import Script from 'next/script'
import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { isSignupRoute } from '../utils/isSignupRoute'
import { runOnInteractionOrTimeout } from '../utils/runOnInteractionOrTimeout'

const FB_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID

/** Lightweight fbq stub so metaPixelEvent can queue conversions before fbevents.js loads. */
const facebookPixelStub = `
!function(f,n){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];}(window);
`

/** Loads fbevents.js and boots PageView. Safe when the stub already created window.fbq. */
const facebookPixelLoader = `
(function(f,b,e,v,t,s){
  if(f.__fbPixelScriptRequested)return;f.__fbPixelScriptRequested=1;
  t=b.createElement(e);t.async=!0;t.src=v;
  s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s);
  fbq('init','${FB_PIXEL_ID}');
  fbq('track','PageView');
})(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
`

const Scripts = () => {
  const router = useRouter()
  const onSignup =
    isSignupRoute(router.pathname) || isSignupRoute(router.asPath)
  // Signup stays quiet until a real interaction. requestIdleCallback fires
  // immediately after hydrate and was pulling GTM back into the LCP window.
  const [allowHeavyScripts, setAllowHeavyScripts] = useState(!onSignup)

  useEffect(() => {
    if (!onSignup) {
      setAllowHeavyScripts(true)
      return
    }

    return runOnInteractionOrTimeout(() => setAllowHeavyScripts(true), {
      includeScroll: true
    })
  }, [onSignup])

  if (process.env.NODE_ENV !== 'production') {
    return null
  }

  return (
    <>
      {FB_PIXEL_ID && (
        <Script
          id="fb-pixel-stub"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{ __html: facebookPixelStub }}
        />
      )}

      {allowHeavyScripts && (
        <>
          <Script
            strategy="lazyOnload"
            dangerouslySetInnerHTML={{
              __html: `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-TPSQ744');
              `
            }}
          />
          <noscript
            dangerouslySetInnerHTML={{
              __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TPSQ744"
            height="0" width="0" style="display:none;visibility:hidden"></iframe>`
            }}
          ></noscript>
          <Script
            strategy="lazyOnload"
            dangerouslySetInnerHTML={{
              __html: `
          (function(){var t=document.createElement("script");t.type="text/javascript",t.async=!0,t.src='https://cdn.firstpromoter.com/fprom.js',t.onload=t.onreadystatechange=function(){var t=this.readyState;if(!t||"complete"==t||"loaded"==t)try{$FPROM.init("mcayz5uz",".worshiponline.com")}catch(t){}};var e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(t,e)})();
              `
            }}
          />
          {FB_PIXEL_ID && (
            <Script
              id="fb-pixel"
              strategy="lazyOnload"
              dangerouslySetInnerHTML={{ __html: facebookPixelLoader }}
            />
          )}
        </>
      )}
    </>
  )
}

export default Scripts
